'use client';

import { SearchIcon } from '@wolfejs/icons/IconMap';
import { Button } from '@wolfejs/ui/Button/Button';
import { Input } from '@wolfejs/ui/Input';
import type { UIThemableComponent } from '@wolfejs/ui/types/UI';
import { cn } from '@wolfejs/ui/utils/classnames';
import React from 'react';

export type GlobalSearchBoxProps = UIThemableComponent & {
  onSubmit?: (value: string) => void;
  placeholder?: string;
  searchInput?: string;
  buttonText?: React.ReactNode;
};
export const GlobalSearchBox = ({
  placeholder = 'Search...',
  buttonText = 'Search',
  searchInput,
  classNames,
  onSubmit,
}: GlobalSearchBoxProps) => {
  const [searchValue, setSearchValue] = React.useState<string>();
  const [isFocused, setIsFocused] = React.useState(false);
  return (
    <div
      className={cn('border-default-300 inline-flex rounded-lg border shadow-sm lg:w-[455px]', {
        ['ring-info ring']: isFocused,
      })}
      role="group"
    >
      <Input
        placeholder={placeholder}
        shape="rect"
        size="xs"
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        initialValue={searchInput}
        className={cn('focus:none flex-1 rounded-l-lg ring-0', classNames?.input)}
        onChange={(ev: React.ChangeEvent<HTMLInputElement>) => setSearchValue(ev.target.value)}
        prepend={<SearchIcon className="text-default-300 h-4 w-4" />}
      />
      <Button
        shape="rect"
        className={cn('border-primary rounded-r-lg border', classNames?.button)}
        color={'primary'}
        size="xs"
        onClick={() => onSubmit?.(searchValue as string)}
      >
        {buttonText}
      </Button>
    </div>
  );
};
